// 저장소 헬퍼

// =================================================================================================
// 가져오기
// =================================================================================================
// 고정 영역

// 동적 영역
import logHelper from './logHelper';
import objectHelper from './objectHelper';
import stringHelper from './stringHelper';
import AsyncStorage from '@react-native-async-storage/async-storage'; // 비동기 비보안 데이터 저장

// =================================================================================================
// 상수
// =================================================================================================
// 로컬 데이터 셋 (비보안) (비동기)
const asyncSet = async (key, value) => {
  try {
    let type = typeof value;
    if (type == 'object') {
      value = stringHelper.valueOfObject(value); // object to string
    } else {
    }
    await AsyncStorage.setItem(key + '▒' + 'type', type);
    await AsyncStorage.setItem(key, value);
  } catch (e) {
    logHelper.error(e);
    return false;
  }
  return true;
};

// 로컬 데이터 겟 (비보안) (비동기)
const asyncGet = async (key) => {
  let result;
  try {
    let type = await AsyncStorage.getItem(key + '▒' + 'type');
    if (type !== null) {
      // value previously stored
    }
    if (type == 'object') {
      const sObjectString = await AsyncStorage.getItem(key);
      if (sObjectString != null) {
        result = objectHelper.valueOfString(sObjectString);
      } else {
        result = null;
      }
    } else {
      result = await AsyncStorage.getItem(key);
    }
    if (result !== null) {
      // value previously stored
    }
  } catch (e) {
    logHelper.error(e);
  }
  return result;
};

// =================================================================================================
// 내보내기
// =================================================================================================
export default {
  asyncGet,
  asyncSet,
};
